import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDPrimaryActionButton,
  FDStack, FDTextButton,
} from '@facet-wealth/design';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import WizardStepDeleteButton from 'Views/Page/Content/Modal/Layouts/DefaultFDWizardStep/Layout/WizardStepDeleteButton';
import { DialogActions, DialogContent } from 'Views/Page/Content/Modal/Components';
import { FDInputRow } from 'Packages/FacetDesign/Components/Experimental/fdInputRow';
import { FormSection } from 'Components/ComponentLibrary/Molecules/FormSection';

const Layout = () => {
  const { resource, onSubmit, saving } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();

  const handleCancel = () => {
    clearModalCollection();
  };

  async function handleDelete() {
    return resource.delete();
  }

  const onDeleteSuccess = async () => {
    clearModalCollection();
  };

  return (
    <>
      <MetaControlField attr={'title'} />
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FormSection>
          <MetaControlField attr={'subtitle'} />
          <FDStack spacing={2}>
            <MetaControlField attr={'clientId'} flex={1} />
          </FDStack>
          <FDInputRow>
            <MetaControlField attr={'incomeType'} flex={1} />
            <MetaControlField attr={'name'} flex={1} />
            <MetaControlField attr={'frequencyGrossValue'} flex={1} />
            <MetaControlField attr={'frequency'} flex={1} />
            <MetaControlField attr={'socialSecurityBenefitType'} flex={1} />
            <MetaControlField attr={'company'} flex={1} />
            <MetaControlField attr={'benefitElection'} flex={1} />
            <MetaControlField attr={'survivorshipRate'} flex={1} />
            <MetaControlField attr={'numberOfYears'} flex={1} />
          </FDInputRow>
          <MetaLayoutRemainingFields />
          {resource.meta().canDelete() ? (
            <WizardStepDeleteButton
              onDelete={handleDelete}
              onDeleteSuccess={onDeleteSuccess}
              dialogProps={{
                title: 'Are you sure?',
                message: 'Removing this item will delete all of its information. This cannot be undone.',
                confirmLabel: 'Remove',
              }}
            />
          ) : null}
        </FormSection>
      </DialogContent>
      <DialogActions>
        <FDTextButton
          onClick={handleCancel}
          label="Cancel"
        />
        <FDPrimaryActionButton
          loading={saving}
          onClick={onSubmit}
          label="Submit"
        />
      </DialogActions>
    </>
  );
};

export default Layout;
